import { Component, OnInit } from '@angular/core';
import {  ViewChild, ViewEncapsulation } from "@angular/core";
import { Route, Router } from '@angular/router';
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.scss',"../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class PaymentListComponent implements OnInit {
    @ViewChild(DatatableComponent) table: DatatableComponent;
    page = {
      pageNumber:0,
      offset: 0,
      pageSize: 100,
      totalPages:0
    };
    // row data
    public rows = [];
    public filterRows=[];
    public ColumnMode = ColumnMode;
    public limitRef = 10;
    selectedValue=''
    isFilter:boolean=false;
    public columns = [
      { name: "Name", prop: "name" },
      { name: "Net Fee", prop: "net_amount" },
      { name: "Total Paid", prop: "amount" },
      { name: "Paid Fee", prop: "paid_amount" },
      { name: "Pending Fee", prop: "pendingAmount" },
      { name: "Payment Status", prop: "payment_status" },
      {name:"Transaction Date",prop:"createdOn"},  
      { name: "Actions", prop: "Actions" },
    ];
  
    // private
    private tempData = []; 
  
    imageUrl='http://18.189.74.89:5000/assets/images/'
    transaction_id:any
    constructor( public apiService:ApiService,
                 public toastr: ToastrService,
                 private route:Router) {  }
  
    ngOnInit(): void {
      this.getTransactionsList()
    }
   
    getTransactionsList(){
      this.apiService.getTransactionList(this.page.pageNumber+1,this.limitRef).subscribe((res:any)=>{
        this.rows=res.data.items
        this.page.totalPages=res.data.totalCount
        console.log('transaction list',this.rows)
      })
    }
    pageChangeData(page:any){
      this.apiService.getTransactionList(page.offset +1,page.pageSize).subscribe((res:any)=>{
        this.rows=res.data.items
        console.log('page change',res)
        this.page.totalPages=res.data.totalCount
      })
    }
    editTransaction(id:any){
      console.log('id=>> ',id)
    }
    deleteTransaction(){
      if(this.transaction_id){
        this.apiService.deleteTransaction(this.transaction_id).subscribe((res:any)=>{
          console.log(res)
          if(res.statusCode === 200){
            this.getTransactionsList()
          }
          else{
            this.toastr.error(res.error)
          } 
          })
      }
      else{
        this.toastr.error('something went wrong !!')
      }
    }
   
     // ================== Delete Alert ========================
     ConfirmColor(id:any) {
      this.transaction_id=id
      console.log('id==>',this.transaction_id)
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2F8BE6',
        cancelButtonColor: '#F55252',
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-warning',
          cancelButton: 'btn btn-danger ml-1'
        },
        buttonsStyling: false,
      }).then( (result)=> {
        if (result.value) {  
          this.deleteTransaction()      
          swal.fire({
            icon: "success",
            title: 'Deleted!',
            text: 'Your imaginary file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'Your imaginary file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
    }
    
    // ==========================================
     // Public Methods
    // -----------------------------------------------------------------------------------------------------
  
    /**
     * filterUpdate
     *
     * @param event
     */
     filterUpdate(event) {
      const val = event.target.value.toLowerCase();
  
      // filter our data
      const temp = this.tempData.filter(function (d) {
        return d.Username.toLowerCase().indexOf(val) !== -1 || !val;
      });
  
      // update the rows
      this.rows = temp;
      this.filterRows=temp
      // Whenever the filter changes, always go back to the first page
      this.table.offset = 0;
    }
  
    /**
     * updateLimit
     *
     * @param limit
     */
    updateLimit(limit) {
      this.limitRef = limit.target.value;
      this.apiService.getTransactionList(1,this.limitRef).subscribe((res:any)=>{
        this.rows=res.data.items
        console.log('limit',res)
      })
    }
  
  }
  
